module.exports = __webpack_public_path__ + "static/img/mobile.b9e0a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/mobile.png
// module id = 9uLH
// module chunks = 1